import { useApiGet } from "./Api.hooks";

const endpoint = `/api/order-entry-summary`;

export const useGetOrderEntrySummary = () => {
  return useApiGet(endpoint);
};
